import { render, staticRenderFns } from "./CopyRightEnglishPage.vue?vue&type=template&id=e283990e&scoped=true"
import script from "./CopyRightEnglishPage.vue?vue&type=script&lang=ts"
export * from "./CopyRightEnglishPage.vue?vue&type=script&lang=ts"
import style0 from "./CopyRightEnglishPage.vue?vue&type=style&index=0&id=e283990e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e283990e",
  null
  
)

export default component.exports